import {IDiscountType} from "../interfaces/IDiscounts"
export const SET_DISCOUNT_TYPE = "SET_DISCOUNT_TYPE";
export function setDiscountType(value: IDiscountType) {
    return {
        type: SET_DISCOUNT_TYPE,
        payload: value
    }
};
export const SET_DISCOUNT_CODE = "SET_DISCOUNT_CODE";
export function setDiscountCode(value: string) {
    return {
        type: SET_DISCOUNT_CODE,
        payload: value
    }
};